export enum NotificationScheduleType {
	UPDATE = 'update', // scheduled to send actual data
	REMINDER = 'reminder', // scheduled, but not sending actual data
	ALERT = 'alert', // no schedule, must be triggered by something
}

export enum NotificationFilterType {
	METRIC = 'metric',
	SCORECARD = 'scorecard',
	ALERT = 'alert',
	BOARD = 'board',
	LOOP = 'loop',
	REPORT = 'report',
	GOAL = 'goal',
}

export enum NotificationFilterFrequency {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	BIWEEKLY = 'biweekly',
	MONTHLY = 'monthly',
	QUARTERLY = 'quarterly',
	CONDITIONAL = 'conditional',
	STATUS_CHANGE = 'status_change',
	ANOMALY = 'anomaly',
}

export enum NotificationCreateType {
	METRIC = 'metric',
	BOARD = 'board',
	REPORT = 'report',
	REMINDER = 'reminder',
	SCORECARD = 'scorecard',
	ALERT = 'alert',
	SMART_ALERT = 'smart-alert',
}
